import { ApplicationInsights } from "@microsoft/applicationinsights-web";

const disableTelemetry = localStorage.getItem("debug_disable_app_insights") === "1" && import.meta.env.NODE_ENV === "development";

export const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: import.meta.env.APP_INSIGHTS_KEY,
    disableTelemetry,
    enableAutoRouteTracking: true
  }
});

appInsights.loadAppInsights();
appInsights.trackPageView();
